import { BaseModel } from "sjs-base-model";

export default class DashboardSimulazioneFormModel extends BaseModel {
    public readonly cliente: string = "";
    public readonly tipoRichiesta: string = "";
    public readonly importo: string = "";
    public readonly dataNascita: string = "";
    public readonly importoMensile: string = "";

    constructor(data: Partial<DashboardSimulazioneFormModel>) {
        super();

        this.update(data);
    }
}
